import {
  AfterContentChecked,
  Directive,
  HostListener,
  OnDestroy,
  OnInit,
} from "@angular/core";

@Directive({
  selector: "[claasScrollAnchor]",
})
export class ScrollAnchorDirective
  implements AfterContentChecked, OnDestroy, OnInit
{
  private hasScrolled = false;
  private popstateHandler = () => {
    this.hasScrolled = false;
    this.scrollToAnchor(window.location.hash);
  };

  ngOnInit() {
    window.addEventListener("popstate", this.popstateHandler);
  }

  ngAfterContentChecked() {
    if (!this.hasScrolled && window.location.hash) {
      this.hasScrolled = this.scrollToAnchor(window.location.hash);
    }
  }

  ngOnDestroy() {
    window.removeEventListener("popstate", this.popstateHandler);
  }

  // case: anchor link clicked
  @HostListener("document:click", ["$event"])
  onAnchorClick(evt: MouseEvent) {
    const target = evt.target as HTMLElement | null;
    const anchor = target?.closest('a[href*="#"]') as HTMLAnchorElement | null;
    if (!anchor) return;

    evt.preventDefault();
    evt.stopPropagation();

    this.hasScrolled = false;
    this.scrollToAnchor(anchor.hash);
  }

  private scrollToAnchor(hash: string) {
    if (!hash) return false;
    const fragment = hash.slice(1);
    const el = document.getElementById(fragment);
    const scrollContainer = document.querySelector("mat-sidenav-content");

    if (el && scrollContainer && scrollContainer.contains(el)) {
      const containerRect = scrollContainer.getBoundingClientRect();
      const elRect = el.getBoundingClientRect();
      const scrollTopPosition = elRect.top - containerRect.top;

      (scrollContainer as HTMLElement).scrollTo({
        left: 0,
        top: scrollTopPosition,
        behavior: "smooth",
      });

      return true;
    }

    return false;
  }
}
